import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@mui/material/IconButton';
import prof from './images/test-result.png';
import { DropzoneArea } from 'material-ui-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export default class ImportQuestions extends Component {
	
	constructor(props) 
	  {super();
		 this.state = {redirect:false,pagename:'',errormessage:'',open:false,imgfile:'',primarybtntext:'Upload',Classarr:[],classid:'',classlabel:'Select Class',examarray:[],exam:'',rolelabel1:'Select exam',uploadedFileName:'',}
	  }
			componentWillMount() { 
localStorage.setItem("pageactive",6)
}
 componentDidMount()
	{
		localStorage.setItem("pageactive","5")
		this.ClassBind();
	}
	handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  OnImportSubmit=(event)=>{
	  
	   if (this.state.classid === "" || this.state.classid === "0" || this.state.exam === "") {
    this.setState({ 
      errormessage: "Please select class and exam.",
      open: true 
    });
    return;
  }

  if (!this.state.imgfile || this.state.imgfile.length === 0) {
    this.setState({ 
      errormessage: "Please select a file to upload.",
      open: true 
    });
    return;
  }
	  
	   var formData = new FormData();
	 formData.append('action','import')
		   formData.append('Filedata', this.state.imgfile[0])
		 formData.append('examId', this.state.exam)
	formData.append('userid',localStorage.getItem("MMCuserid"))
	this.setState({primarybtntext:'Processing...'});
	axios.post(Serverurl+"ajaxexam.php", formData, {
	}).then(res => {
		
		this.setState({primarybtntext:'Upload',open:true,errormessage:'Uploaded successfully',uploadedFileName: res.data.filename });
		
	});
  }
  
  
  
  ClassBind()
{
axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

} 
  
  onloadexambind(){

    axios.get(Serverurl+'ajaxexam.php?action=getall&ex_class='+this.state.classid)
	
    
      .then((response) => {    
     
      this.setState({  examarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.examarray.map(exam => {
                            
          return {value: exam.ex_id, display:exam.ex_name}
        });
      
		
        this.setState({
          examarray: [{value: '', display: 'Select exam'}].concat(roleFromApi)
        });
      })


}
myChangeHandler = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
        if (name === "classid" && value !== "0") {
            this.onloadexambind();
        }
    });
}


	render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	 return (
  
	 <React.Fragment> 
	  <div className="pagebox-col">
	 <div className="">
			<div className="boxheading">
				  <div className="contntpad">
					 <p>  <Collapse in={this.state.open}>
										<Alert
										  action={
											<IconButton
											  aria-label="close"
											  color="inherit"
											  size="small"
											  onClick={() => {
											   this.handleErrorclose();
											  }}
											>
											  <CloseIcon fontSize="inherit" />
											</IconButton>
										  } severity="info"
										>
										{this.state.errormessage}
										</Alert>
								</Collapse></p>
				  <h2><img src={prof} /> Import Questions</h2>
				  </div> </div>
	   <div className="contntpad ">
	    
	    <div className="formview ">
		
		<ul>
		
			  
			  <li>
			    <p><FormControl className="stadrp">
	  
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p></li>
 
		<li><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth

		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel1, value: this.state.exam}}
          onChange={this.myChangeHandler}
          id="exam"
		   value={this.state.exam}
		  name="exam"
		
		
        >
		{this.state.examarray.map(exam => (
            <option  
            
              value={exam.value}
            >
              {exam.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  </li>
				
		</ul></div><div className="clear">
		
	    <div className="formviewatt ">
	<p><a href={Serverurl + "uploads/1254639581_questions.csv"} className="frmsecondarybtn" target="_blank">Download CSV File</a>
	</p>
	 <p className="fileuploaddrop">
	   <DropzoneArea dropzoneText="" 
 showPreviews={true}
  showPreviewsInDropzone={false}
  useChipsForPreview
  previewGridProps={{container: { spacing: 1, direction: 'row' }}}
dropzoneText={"Drag and drop/Select CSV file here"}
  previewText="Uploaded files"
maxFileSize={5000000} Icon={CloudUploadIcon} dropzoneClass="filesupld" filesLimit={1} acceptedFiles={['text/csv']} 
 
 
  onChange={(files) => {
  var file, img;
  var _URL = window.URL || window.webkitURL;
  this.setState({ imgfile: files })
  
		
 

  }}
  
 
/></p>  <p className="alignright"><Button variant="standard" className="frmPrimarybtn" endIcon={<CheckRoundedIcon />} onClick={this.OnImportSubmit}>
								  {this.state.primarybtntext}
						</Button></p>
	   <div className="clear"></div>
	   </div>  </div>
	   </div>
	   </div></div>
	 </React.Fragment> 
	 )
	}
}








